export const ADD_DUPE_EXT_VEHICLE_INDEX = 'ADD_DUPE_EXT_VEHICLE_INDEX';
export const REMOVE_DUPE_EXT_VEHICLE_INDEX = 'REMOVE_DUPE_EXT_VEHICLE_INDEX';
export const CLEAN_DUPE_EXT_VEHICLE_INDEX = 'CLEAN_DUPE_EXT_VEHICLE_INDEX';
